import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import { io } from "socket.io-client";
import "../styles/game.css";

class Game extends Component {

  constructor(props) {

    super(props);

    this.socket = null;

    this.timerInterval = null;

    this.joinedGame = false;

    this.state = {
      user: null,
      gameId: null,
      board: Array(9).fill(null),
      symbol: "",
      currentTurn: "",
      message: "Connecting...",
      timer: 20,
      selectedIndex: null,
      amount: 100,
    };

  }

  componentDidMount() {

    let user = this.props.location?.state?.user;

    if (!user) {
      this.props.navigate("/", {
        replace: true
      });
      return;
    }

    this.setState({ user });

    this.socket = io(
      "https://api.hi-bigame.online",
      {
        transports: ["websocket", "polling"],
      }
    );

    this.socket.on("connect", () => {

      console.log("SOCKET CONNECTED");

      if (this.joinedGame) return;

      this.joinedGame = true;

      this.socket.emit("joinGame", {
        userId: user.id,
        amount:
          this.props.location?.state?.amount ||
          100
      });

    });

    this.socket.on("waiting", () => {

      this.setState({
        message: "Waiting for opponent..."
      });

    });

    this.socket.on(
      "alreadyPlaying",
      async () => {

        alert(
          "Already Playing In Another Match ⚠️"
        );

        await this.goHome();

      }
    );

    this.socket.on(
      "startGame",
      ({ symbol, gameId }) => {

        this.setState({
          symbol,
          gameId,
          currentTurn: "X",
          board: Array(9).fill(null),
          selectedIndex: null,
          timer: 20,
          message:
            symbol === "X"
              ? "Your Turn 🎮"
              : "Opponent Turn ⏳",
        });

        this.startTimer();

      }
    );

    this.socket.on(
      "opponentMove",
      ({ board, currentTurn }) => {

        this.setState({
          board,
          currentTurn,
          selectedIndex: null,
          message:
            currentTurn === this.state.symbol
              ? "Your Turn 🎮"
              : "Opponent Turn ⏳",
        });

        this.resetTimer();

      }
    );

    this.socket.on(
      "gameEnded",
      async ({ winnerId }) => {

        clearInterval(
          this.timerInterval
        );

        if (
          winnerId ===
          this.state.user.id
        ) {

          this.setState({
            message:
              "🎉 YOU WIN 🎉",
          });

        } else {

          this.setState({
            message:
              "😢 YOU LOSE 😢",
          });

        }

        setTimeout(async () => {

          await this.goHome();

        }, 3000);

      }
    );

    this.socket.on(
      "noOpponent",
      async () => {

        clearInterval(
          this.timerInterval
        );

        alert(
          "No Opponent Found 💰"
        );

        await this.goHome();

      }
    );

    this.socket.on(
      "lowBalance",
      () => {

        alert("Low Balance ❌");

        this.props.navigate(
          "/home"
        );

      }
    );

    this.socket.on(
      "connect_error",
      (err) => {

        console.log(
          "SOCKET ERROR",
          err
        );

      }
    );

    window.addEventListener(
      "beforeunload",
      this.handleLeave
    );

  }

  handleLeave = () => {

    if (
      this.socket &&
      this.state.gameId
    ) {

      this.socket.emit(
        "exitGame",
        {
          gameId:
            this.state.gameId,
          userId:
            this.state.user.id
        }
      );

    }

  };

  goHome = async () => {

    try {

      const token =
        localStorage.getItem(
          "token"
        );

      const res = await fetch(
        `https://api.hi-bigame.online/user/${this.state.user.id}`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      const updatedUser =
        await res.json();

      this.props.navigate(
        "/home",
        {
          replace: true,
          state: {
            user: updatedUser
          },
        }
      );

    } catch {

      this.props.navigate(
        "/home"
      );

    }

  };

  startTimer = () => {

    clearInterval(
      this.timerInterval
    );

    this.setState({
      timer: 20
    });

    this.timerInterval =
      setInterval(() => {

        this.setState((prev) => {

          const next =
            prev.timer - 1;

          if (next <= 0) {

            clearInterval(
              this.timerInterval
            );

            if (
              this.state.gameId
            ) {

              this.socket.emit(
                "exitGame",
                {
                  gameId:
                    this.state.gameId,
                  userId:
                    this.state.user.id,
                }
              );

            }

            return {
              timer: 0
            };

          }

          return {
            timer: next
          };

        });

      }, 1000);

  };

  resetTimer = () => {

    clearInterval(
      this.timerInterval
    );

    this.setState(
      {
        timer: 20,
      },
      () => {
        this.startTimer();
      }
    );

  };

  countMySymbols = () => {

    return this.state.board.filter(
      (x) =>
        x === this.state.symbol
    ).length;

  };

  isAdjacent = (from, to) => {

    const allowedMoves = {
      0: [1, 3],
      1: [0, 2, 4],
      2: [1, 5],
      3: [0, 4, 6],
      4: [1, 3, 5, 7],
      5: [2, 4, 8],
      6: [3, 7],
      7: [4, 6, 8],
      8: [5, 7],
    };

    return allowedMoves[from]
      .includes(to);

  };

  handleClick = (index) => {

    const {
      board,
      symbol,
      currentTurn,
      gameId,
      selectedIndex,
    } = this.state;

    if (!gameId) return;

    if (symbol !== currentTurn)
      return;

    const myCount =
      this.countMySymbols();

    if (myCount < 3) {

      if (board[index]) return;

      const newBoard = [...board];

      newBoard[index] = symbol;

      const nextTurn =
        symbol === "X"
          ? "O"
          : "X";

      this.setState({
        board: newBoard,
        currentTurn: nextTurn,
        message:
          "Opponent Turn ⏳",
      });

      this.socket.emit(
        "playerMove",
        {
          gameId,
          symbol,
          index,
          type: "place",
        }
      );

      this.checkWinner(
        newBoard
      );

      return;

    }

    if (selectedIndex === null) {

      if (
        board[index] !== symbol
      ) return;

      this.setState({
        selectedIndex: index,
      });

      return;

    }

    if (selectedIndex === index) {

      this.setState({
        selectedIndex: null,
      });

      return;

    }

    if (board[index] !== null)
      return;

    if (
      !this.isAdjacent(
        selectedIndex,
        index
      )
    ) return;

    const newBoard = [...board];

    newBoard[selectedIndex] =
      null;

    newBoard[index] = symbol;

    const nextTurn =
      symbol === "X"
        ? "O"
        : "X";

    this.setState({
      board: newBoard,
      selectedIndex: null,
      currentTurn: nextTurn,
      message:
        "Opponent Turn ⏳",
    });

    this.socket.emit(
      "playerMove",
      {
        gameId,
        symbol,
        from: selectedIndex,
        to: index,
        type: "move",
      }
    );

    this.checkWinner(
      newBoard
    );

  };

  checkWinner = (board) => {

    const wins = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];

    for (let [a, b, c] of wins) {

      if (
        board[a] &&
        board[a] === board[b] &&
        board[a] === board[c]
      ) {

        this.socket.emit(
          "gameOver",
          {
            gameId:
              this.state.gameId,
            winnerId:
              this.state.user.id,
          }
        );

        return;

      }

    }

  };

  componentWillUnmount() {

    clearInterval(
      this.timerInterval
    );

    window.removeEventListener(
      "beforeunload",
      this.handleLeave
    );

    this.joinedGame = false;

    if (this.socket) {
      this.socket.disconnect();
    }

  }

  render() {

    const {
      board,
      timer,
      message,
      symbol,
      currentTurn,
      selectedIndex,
    } = this.state;

    return (
      <div>

        <div className="game-page">

          <div
            className="game-card"
            style={{
              boxShadow:
                currentTurn === symbol
                  ? "0 0 25px limegreen"
                  : "0 0 25px red"
            }}
          >

            <h2 className="game-title">
              Game
            </h2>

            <h2
              className="game-message"
              style={{
                color:
                  message.includes(
                    "WIN"
                  )
                    ? "green"
                    : message.includes(
                        "LOSE"
                      )
                    ? "red"
                    : "black"
              }}
            >
              {message}
            </h2>

            <h3 className="game-timer">
              ⏱️ {timer}s
            </h3>

            <h3 className="game-turn">
              You: {symbol}
              <br />

              {currentTurn === symbol
                ? "🟢 Your Turn"
                : "🔴 Opponent Turn"}
            </h3>

            <div className="game-board">

              {board.map(
                (cell, i) => (

                  <div
                    key={i}
                    onClick={() =>
                      this.handleClick(i)
                    }
                    className={
                      selectedIndex === i
                        ? "game-cell selected-cell"
                        : "game-cell"
                    }
                  >

                    {cell && (

                      <div
                        className={
                          cell === "X"
                            ? "game-ball red-ball"
                            : "game-ball blue-ball"
                        }
                      ></div>

                    )}

                  </div>

                )
              )}

            </div>

          </div>

        </div>

      </div>
    );

  }

}

export default withNavigation(Game);